module.exports = __webpack_public_path__ + "img/data_box_goods.bb4c78c6.png";